import { useEffect } from "react"
import { getInterfaceLanguage, setInterfaceLanguage } from "@/api"
import { TranslateCookieHandler } from "@/components/Translate/google-translate"
import i18n, { getSavedLanguage, hasExplicitLanguagePreference } from "@/i18n"

export const InterfaceLanguageSync = () => {
    useEffect(() => {
        void (async () => {
            try {
                const { language } = await getInterfaceLanguage()
                if (hasExplicitLanguagePreference()) {
                    const localLanguage = getSavedLanguage()
                    if (localLanguage !== language) {
                        await setInterfaceLanguage(localLanguage).catch(() => {
                            // Keep the local preference when the sync request fails.
                        })
                    }
                    return
                }

                TranslateCookieHandler(`/auto/${language}`)
                if (i18n.isInitialized && i18n.language !== language) {
                    await i18n.changeLanguage(language)
                }
            } catch {
                // The UI language remains available locally if the sync request fails.
            }
        })()
    }, [])

    return null
}
